import React from "react";
import { LeadRequirement } from "../../core/api/models/requirement";
import { CreateProposalCoverHeaderGallery } from "./create-proposal-cover-header-gallery";

interface CreateProposalCoverGalleryPopupProps {
    proposalCoverImages: any[];
    requirementData: LeadRequirement;
    selectedCoverImages: any[];
    setCoverGalleryPopup: React.Dispatch<React.SetStateAction<boolean>>;
    setCoverSelectedImages: React.Dispatch<React.SetStateAction<any[]>>;
    title?: string
}

export function CreateProposalCoverGalleryPopup({ proposalCoverImages,
    requirementData,
    selectedCoverImages,
    setCoverGalleryPopup,
    title,
    setCoverSelectedImages }: CreateProposalCoverGalleryPopupProps) {
    return (
        <>
            <div
                className={`detail-poupup  position-fixed top-0 w-100 h-100 overflow-auto in `}
                style={{ zIndex: 1051 }}
                id="coverGalleryPopup"
            >

                <CreateProposalCoverHeaderGallery
                    title={title}
                    setCoverGalleryPopup={setCoverGalleryPopup}
                />

                <div className="py-4 px-5">
                    <div className="row img-uploader-gallery gutter-5 py-1">
                        {proposalCoverImages.map((image, index) => {
                            if (image?.propertyTypes?.includes(requirementData?.propertyTypeDetails?.propertyTypeName)) {
                                return (
                                    <div
                                        className="col-sm-3"
                                        key={index + 'cover-image'}
                                        style={{ marginBottom: "10px" }}
                                    >
                                        <div className="item-img-upload overflow-hidden position-relative w-100">
                                            <img
                                                src={image?.media?.location}
                                                alt="img"
                                                className="img-fluid h-100 w-100"
                                            />
                                            <span className="strap d-block position-absolute text-uppercase text-white font-weight-semibold">
                                                {image?.media?.originalname}
                                            </span>
                                            <span className="checkbox d-flex justify-content-center align-items-center position-absolute rounded-circle">
                                                <input
                                                    type="checkbox"
                                                    name="checkprop-create-proposal-cover"
                                                    id={`item_cover_${index}`}
                                                    checked={selectedCoverImages.some((item) => image._id === item._id)}
                                                    onClick={() => {
                                                        if (selectedCoverImages.some((item) => image._id === item._id)) {
                                                            setCoverSelectedImages(prev => prev.filter(img => img?._id !== image._id))
                                                        } else {
                                                            setCoverSelectedImages(prev => [image])
                                                        }
                                                    }}
                                                />
                                                <label htmlFor={`item_cover_${index}`}></label>
                                            </span>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                        <div className="col-sm-12 mt-5 text-right">
                            <button
                                className="btn btn-primary font-normal font-weight-semibold px-4 py-2"
                                style={{ height: "40px", borderRadius: "4px" }}
                                onClick={() => setCoverGalleryPopup(false)}
                            >
                                Add Photo
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
        </>
    );
}
